module.exports = __webpack_public_path__ + "static/media/wood.39979b64.png";